import { axios } from "utils";

import { ADMIN_DOC_SCANS_URL as endpoint } from "consts";

import {
  CreateDocScanResponse,
  DocScanFieldRecord,
  DocScanFieldSortBy,
  DocScanGlobalStatistics,
  DocScanJobDetail,
  DocScanSortBy,
  DocScanSortOrder,
  DocScanType,
  GetDocScansResponse,
  ListDocScanFieldsResponse,
} from "models";

export const listFarmDocumentScans = async (data: {
  page: number;
  limit: number;
  sortBy: DocScanSortBy;
  sortOrder: DocScanSortOrder;
}): Promise<GetDocScansResponse> => axios.get(endpoint, { data });

export const getFarmDocumentScanById = async (data: { id: string }): Promise<DocScanJobDetail> => axios.get(`${endpoint}/${data.id}`, { data });

export const listFarmDocumentScanFields = async (data: {
  id: string;
  page: number;
  limit: number;
  sortBy: DocScanFieldSortBy;
  sortOrder: DocScanSortOrder;
  overallStatus?: string;
}): Promise<ListDocScanFieldsResponse> => axios.get(`${endpoint}/${data.id}/fields`, { data });

export const patchFarmDocumentScanField = async (data: {
  scanId: string;
  fieldId: string;
  isCorrect: boolean | null;
  comment: string | null;
}): Promise<DocScanFieldRecord> =>
  axios.patch(`${endpoint}/${data.scanId}/fields/${data.fieldId}/comment`, {
    data: { isCorrect: data.isCorrect, comment: data.comment },
  });

export const createFarmDocumentScanFromDocument = async (data: {
  farmId: string;
  file: string;
  fileType: string;
  fileName: string;
  fileHash?: string;
  type: DocScanType;
}): Promise<CreateDocScanResponse> => axios.post(endpoint, { data });

export const getDocScanStatistics = async (): Promise<DocScanGlobalStatistics> => axios.get(`${endpoint}/statistics`);
